import React, { useEffect, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";

import "./style.css";
import SuspencePage from "./components/suspence/SuspencePage";
import NotFoundPage from "./components/notFoundPage/NotFoundPage";
import lazyWithRetry from "./utility/lazyWithRetry";

const FallbackComponent = ({ message }) => {
  return (
    <div className="fallback-container">
      <div className="fallback-content">
        <div className="fallback-icon">
          <img src="./host-images/error.png" alt="Error" />
        </div>
        <div className="fallback-message">
          <h2>Service Unavailable</h2>
          <p>{message}</p>
          <button onClick={refreshPage} className="retry-button">
            Retry
          </button>
        </div>
      </div>
    </div>
  );
};

function refreshPage() {
  window.location.reload(true);
}
// Higher-order function for lazy loading with error handling
const lazyLoadWithFallback = (importFunc, message) => {
  return lazyWithRetry(() =>
    importFunc().catch(() => ({
      default: () => <FallbackComponent message={message} />,
    })),
  );
};

// Lazy imports with error handling and custom messages
const RTTV7APP = lazyLoadWithFallback(
  () => import("./utility/rttwebv7"),
  "You are in Offline ! RTTWebV7 not available",
);
const INTERNALAPP = lazyLoadWithFallback(
  () => import("./utility/etranscentral"),
  "You are in Offline ! eTransCentral not available",
);

const App = () => {
  /** Set Global Variable to check that V7 running independently or Via Container-app */
  window.isV7RunFromContainer = true;
  return (
    <Suspense fallback={<SuspencePage />}>
      <Router>
        <TitleManager />
        <Routes>
          <Route path="/v7/*" element={<RTTV7APP />} />
          <Route path="/central/*" element={<INTERNALAPP />} />
          <Route path="/" element={<Navigate replace to="/v7" />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </Suspense>
  );
};

const TitleManager = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = location.pathname.startsWith("/central")
      ? "eTrans Central"
      : "RTTWebV7";
  }, [location]);
  return <></>;
};

export default App;
